/**
 * reGetuserInfo 無參數重抓時的查詢參數決策。
 *
 * 修正：ukey 登入的使用者重抓時，舊預設只送 {dvc, jkey} 會被後端當成
 * 匿名裝置查詢（rtn 100），setUser 不會執行且完全靜默——卡片入座數等
 * 依 user 的畫面因此不更新。有 ukey 一律優先用 ukey；沒有才走原本的
 * dvc/jkey（裝置登入流程維持不變）。呼叫端有明確給參數時原樣使用。
 */
export function resolveUserInfoQuery(request, { ukey, dvc, jkey } = {}) {
    if (request) return request;
    if (ukey) return { ukey };
    return { dvc, jkey };
}
